module.exports = __webpack_public_path__ + "img/share.b3f1bb07.svg";